(function(window) {
    'use strict'

    const internal = window.RTAnalyticsInternal
    const definitions = {}

    function defineEvent(name, definition) {
        if (!name || definitions[name] || !definition || !Array.isArray(definition.routes)) {
            return false
        }

        const routeIds = definition.routes.map(function(route) {
            return route.id
        })
        if (routeIds.some(function(routeId, index) {
            return !routeId || routeIds.indexOf(routeId) !== index
        })) {
            return false
        }

        definitions[name] = {
            version: definition.version || 1,
            routes: definition.routes.slice()
        }

        return true
    }

    function getEventDefinition(name) {
        return definitions[name] || null
    }

    function resolveDeliveries(event) {
        const definition = getEventDefinition(event.name)
        if (!definition) {
            return []
        }

        return definition.routes.reduce(function(deliveries, route) {
            if (!route.id || !route.provider || !route.action || typeof route.map !== 'function') {
                return deliveries
            }

            let resolved
            try {
                resolved = route.map(event, internal.config) || null
            } catch (error) {
                resolved = null
            }

            if (!resolved || !resolved.recipient) {
                return deliveries
            }

            deliveries.push({
                id: [event.id, route.id].join(':'),
                eventId: event.id,
                routeId: route.id,
                provider: route.provider,
                action: route.action,
                recipient: internal.eventFactory.cloneSerializable(resolved.recipient, {}),
                payload: internal.eventFactory.cloneSerializable(resolved.payload, {}),
                status: 'queued',
                createdAt: event.createdAt,
                expiresAt: event.expiresAt,
                claimedAt: null,
                attemptedAt: null,
                dispatched: null
            })

            return deliveries
        }, [])
    }

    internal.router = Object.freeze({
        defineEvent: defineEvent,
        getEventDefinition: getEventDefinition,
        resolveDeliveries: resolveDeliveries
    })
})(window)
